import React from 'react';
import Breadcrumb from '../common/breadcrumb';
import { generateFavoriteCoursesReport as generateReportService } from '../../services/reports';

const CursosFavoritos = () => {
  const generateReport = async format => {
    await generateReportService(format);
  };

  return (
    <>
      <Breadcrumb
        title="Relatórios - Cursos Favoritos"
        parent="Cursos Favoritos"
      />
      <div className="container-fluid">
        <div className="card">
          <div className="card-header">
            <h5>Cursos Favoritos</h5>
          </div>
          <div className="card-body">
            <form>
              <div className="d-flex justify-content-center align-items-center my-3">
                <button
                  type="button"
                  className="btn btn-primary mr-2"
                  onClick={() => generateReport('pdf')}
                >
                  Gerar Relatório (PDF)
                </button>

                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => generateReport('csv')}
                >
                  Gerar Relatório (CSV)
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CursosFavoritos;
